import {Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {IconIllustration} from 'presentation/components/IconIllustration';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useHostName} from 'presentation/hooks';
import {Container} from './styles';
import {ErrorBillsProps} from './types';

const {error} = translations['pt-br'].privateFlow.myFinancial.paymentsHistory;
const {tryAgain} = translations['pt-br'].commons;

export const ErrorBills = ({handleTryAgain}: ErrorBillsProps) => {
	const {colors} = useTheme();
	const {isNotredameSaude} = useHostName();
	return (
		<Container>
			<Stack
				sx={{
					justifyContent: 'center',
					alignItems: 'center',
					gap: '16px',
				}}>
				<IconIllustration variant="info" />
				<Typography variant="h6" color={colors.light.text.primary} textAlign={'center'}>
					{isNotredameSaude ? error.titleNotredameSaude : error.title}
				</Typography>
				<Typography variant="body1" color={colors.light.text.primary} textAlign={'center'}>
					{error.description}
				</Typography>
				<Button
					variant="outlined"
					endIcon={<Icon name="cached-default" />}
					onClick={handleTryAgain}>
					{tryAgain}
				</Button>
			</Stack>
		</Container>
	);
};
